<template>
    <div
        style="display: flex; flex-direction: column; width: 100%"
    >
        <div class="mb-1" style="display: flex; flex-direction: row; justify-content: space-between;color: #2a3b5199">
        <span>{{ isBlocked ? 'Тариф' : 'Текущая подписка:' }}</span>
        <!-- <span v-if="activePromocode" style="text-decoration: line-through">{{ subscriptionOldPrice }}</span> -->
        </div>
        <div
            style="display: flex; flex-direction: row; justify-content: space-between; width: 100%"
            v-if="isBlocked || subscriptionPrice || currentTariff?.isTrial"
        >
            <div style="display: flex; align-items: center; gap: 8px">
                <h3 style="margin: 0">
                    {{ isBlocked ? blockedTariffName : currentTariff.name }}
                </h3>
                <span
                    v-if="currentTariff?.isTrial"
                    style="
                        display: inline-flex;
                        align-items: center;
                        padding: 2px 10px;
                        border-radius: 999px;
                        background: #e7f7ec;
                        color: #2f8f4e;
                        font-size: 12px;
                        font-weight: 600;
                        line-height: 16px;
                    "
                >
                    Тестовый период
                </span>
            </div>
            <!-- <h3 v-if="!currentTariff.isTrial">{{ subscriptionPrice }}</h3> -->
        </div>
        <div
            style="display: flex; flex-direction: row; justify-content: space-between; width: 100%"
            v-if="isBlocked || subscriptionPrice || currentTariff?.isTrial"
        >
            <span v-if="isBlocked" style="color: #2a3b5199">заблокирован {{ blockedAtLabel }}</span>
            <span v-else style="color: #2a3b5199">активен до {{ activeUntil }}</span>
            <!-- <span v-if="!currentTariff.isTrial" style="color: #2a3b5199">{{ paymentPeriod }}</span> -->
        </div>
        <div
            v-if="tariffPaymentAlert"
            class="tariff-payment-alert"
            :class="`tariff-payment-alert--${tariffPaymentAlert.type}`"
            role="button"
            tabindex="0"
            @click.stop="redirectToSubscriptions"
            @keydown.enter.stop="redirectToSubscriptions"
            @keydown.space.prevent.stop="redirectToSubscriptions"
        >
            <span class="tariff-payment-alert__text">{{ tariffPaymentAlert.text }}</span>
            <v-icon class="tariff-payment-alert__icon">mdi-chevron-right</v-icon>
        </div>
    </div>
</template>

<script>
import Vue, { computed, getCurrentInstance } from 'vue'
import { useBillingStore } from '@root/src/store/stores/billing'
import { useProject } from '@root/src/hooks/useProject'
import useRouter from '@root/src/hooks/useRouter'
import moment from 'moment'

export default Vue.extend({
    setup(props, { emit }) {
        const root = getCurrentInstance().proxy
        const { project } = useProject()
        const { router } = useRouter(root)
        const billingStore = useBillingStore()
        const currentTariff = computed(() => billingStore.getCurrentTariff(project.value.id))
        const previousTariff = computed(() => billingStore.getPreviousTariff(project.value?.id))
        const isBlocked = computed(() => !currentTariff.value && Boolean(previousTariff.value))
        const blockedTariffName = computed(() => previousTariff.value?.name || 'Тариф')
        const blockedAtLabel = computed(() => {
            const raw = previousTariff.value?.uninstalledAt
            if (!raw) return ''
            const date = moment(raw)
            return date.isValid() ? date.format('DD.MM.YYYY') : ''
        })

        const activeUntil = computed(() => {
            const date = new Date(currentTariff.value?.endOfUse)
            return moment(date).format('DD.MM.YYYY')
        })

        const daysUntilTariffEnds = computed(() => {
            const tariffEndOfUse = currentTariff.value?.endOfUse

            if (!tariffEndOfUse) return null

            const endOfUse = moment(tariffEndOfUse)

            if (!endOfUse.isValid()) return null

            return endOfUse.endOf('day').diff(moment().startOf('day'), 'days')
        })

        const tariffPaymentAlert = computed(() => {
            if (isBlocked.value) {
                return {
                    text: 'Подписка не оплачена!',
                    type: 'danger',
                }
            }

            const daysLeft = daysUntilTariffEnds.value

            if (daysLeft === null) return null

            if (daysLeft <= 1) {
                return {
                    text: 'Подписка не оплачена!',
                    type: 'danger',
                }
            }

            if (daysLeft > 4) {
                return {
                    text: 'Подробнее...',
                    type: 'default',
                }
            }

            return {
                text: 'Не забудьте оплатить!',
                type: 'warning',
            }
        })

        const redirectToSubscriptions = () => {
            if (!project.value?.id) return
            if (!project.value?.isChannelsSlots) {
                router.push(`/project/${project.value.id}/billing/?section=tariffs`)
                return
            }

            router.push(`/project/${project.value.id}/billing/?section=subscriptions`)
        }

        const paymentPeriod = computed(() => {
            const period = Number(currentTariff.value?.periodInMonths)
            switch (period) {
                case 1:
                    return 'в месяц'
                    break
                case 3:
                    return 'в 3 месяца'
                    break
                case 6:
                    return 'в 6 месяцев'
                    break
                case 12:
                    return 'в 12 месяцев'
                    break
                case 24:
                    return 'в 24 месяца'
                    break
                default:
                    return ''
            }
        })

        const activePromocode = computed(() => currentTariff.value?.promocodeData?.promocode)

        const subscriptionPrice = computed(() => {
            const tariff = currentTariff.value
            const price = tariff?.price?.toPayPerPeriodWithDiscount || 0
            return tariff?.subscriptionId
                ? billingStore.formatPrice(
                    price
                  )
                : ''
          }
        )

        const subscriptionOldPrice = computed(() => {
            const tariff = currentTariff.value
            return tariff?.subscriptionId
                ? billingStore.formatPrice(tariff.price.regularPay)
                : ''
        })

        return {
            currentTariff,
            isBlocked,
            blockedTariffName,
            blockedAtLabel,
            subscriptionPrice,
            activeUntil,
            paymentPeriod,
            subscriptionOldPrice,
            activePromocode,
            tariffPaymentAlert,
            redirectToSubscriptions
        }
    },
})
</script>

<style lang="sass" scoped>
@import '@/vars.sass'
.tariff-payment-alert
    display: flex
    align-items: center
    justify-content: space-between
    width: 100%
    margin-top: 8px
    color: $main
    cursor: pointer
    font-size: 14px
    font-weight: 400
    line-height: 20px

.tariff-payment-alert--warning
    color: #FD9C2B

.tariff-payment-alert--danger
    color: $dangeour

.tariff-payment-alert__text
    color: inherit !important

.tariff-payment-alert .tariff-payment-alert__icon.v-icon
    color: inherit !important
    font-size: 24px
</style>